// extracted by mini-css-extract-plugin
export default {"footer":"footer__kmcya","socialLink":"socialLink__DgUVN"};